import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import bank from "../../Images/ELEMENTS/bank.png";
import blubimg from "../../Images/ELEMENTS/bulb.png";
import choose from "../../Images/ELEMENTS/choose.png";
import emply from "../../Images/ELEMENTS/employee.png";
import interview from "../../Images/ELEMENTS/handsome-indian-man-giving-kyc-interview.png";
import searchimg from "../../Images/ELEMENTS/hr-human-resources-recruitment-concept-magnifying-glass-focused-icon-professional.png";
import recruitment from "../../Images/ELEMENTS/recruitment.png";
import report from "../../Images/ELEMENTS/report.png";
import requestcpy from "../../Images/ELEMENTS/request copy.png";
import review from "../../Images/ELEMENTS/review.png";
import setting from "../../Images/ELEMENTS/setting.png";
import staffing from "../../Images/ELEMENTS/staffing.png";
import student from "../../Images/ELEMENTS/student.png";

import ModalFormStudent from "../common/ModalFormStudent";

function StudentLandingPage() {
  // const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const benefits = [
    {
      icon: (
        <img src={review} alt="Enhance Profile Icon" className="w-auto h-auto object-cover" />
      ),
      title: "It enhances student profiles",
      description:
        "SelfSync adds depth to each student’s profile by generating rich personality reports. These highlight soft skills, leadership potential, and behavioral strengths — giving recruiters more than just grades to consider.",
    },
    {
      icon: (
        <img src={staffing} alt="Enhance Profile Icon" className="w-auto h-auto object-cover" />
      ),
      title: "It boosts campus placement success",
      description:
        "By revealing how well a student fits a particular role or company culture, SelfSync helps recruiters make better decisions — leading to higher offer rates and stronger job matches.",
    },
    {
      icon: (
        <img
          src={recruitment}
          alt="Enhance Profile Icon"
          className="w-auto h-auto object-cover"
        />
      ),
      title: "It builds credibility with recruiters",
      description:
        "Colleges that offer behavioral insights alongside academic records position themselves as future-ready institutions making a strong impression on companies during campus drives.",
    },
    {
      icon: (
        <img src={student} alt="Enhance Profile Icon" className="w-auto h-auto object-cover" />
      ),
      title: "It helps guide students more effectively",
      description:
        "Placement cells and mentors can use the reports to provide personalized career guidance, helping students understand their strengths, improve self-awareness, and choose aligned career paths.",
    },
    {
      icon: (
        <img src={report} alt="Enhance Profile Icon" className="w-auto h-auto object-cover" />
      ),
      title: "It’s fast and scalable",
      description:
        "SelfSync makes it easy to assess large student batches in a short time, with instant reports and user-friendly dashboards for placement teams to manage and share with recruiters.",
    },
  ];
  const insights = [
    "Personality style",
    "Culture and team fit",
    "Work style and leadership potential",
    "Communication and collaboration traits",
    "Career environment alignment",
  ];

  const results = [
    {
      icon: <img src={choose} alt="Enhance Profile Icon" className="w-auto h-auto object-cover" />,
      text: (
        <>
          More confident hiring <br /> decisions from campus
        </>
      ),
    },
    {
      icon: (
        <img src={setting} alt="Enhance Profile Icon" className="w-auto h-auto object-cover" />
      ),
      text: "Better role student fit",
    },
    {
      icon: <img src={emply} alt="Enhance Profile Icon" className="w-auto h-auto object-cover" />,
      text: (
        <>
          Fewer dropouts post <br /> placement
        </>
      ),
    },
    {
      icon: <img src={bank} alt="Enhance Profile Icon" className="w-auto h-auto object-cover" />,
      text: (
        <>
          Stronger placement <br />
          record for your institution
        </>
      ),
    },
  ];
  return (
    <div className="min-h-screen bg-white bg-gradient-to-br from-blue-50  pt-24">
      <div className="max-w-6xl mx-auto  to-white">
        <div className="grid md:grid-cols-2 gap-12 max-md:gap-2 items-center px-4 pb-8">
          <div className="">
            <h1 className="text-4xl md:text-6xl font-bold text-black mb-6">
              <span className="text-2xl md:text-4xl font-semibold">Help Your Students</span>
              <br />
              <span className="bg-gradient-to-r from-purple-600 to-cyan-500 text-transparent bg-clip-text">
                Get Hired Smarter
              </span>
              <br />
              <span className="bg-gradient-to-r from-purple-600 to-cyan-500 text-transparent bg-clip-text">
                and Faster
              </span>
            </h1>

            <h2 className="text-xl md:text-2xl text-black font-semibold mb-8">
              Empower Your Students with Personality

              Insights That Companies Trust
            </h2>
          </div>

          <div className="flex justify-center">
            <div className="w-full h-80 md:h-96 bg-gray-200 rounded-[30px] flex items-center justify-center">
              <img
                src={interview}
                alt="Students getting hired"
                className="w-full h-full object-cover rounded-[30px]"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-r from-purple-600 to-cyan-600 text-white  px-2 py-10  pb-8 mt-10 text-md md:text-2xl text-center ">
        <p className="text-white ">
          Over <span className="font-bold">9,000</span> businesses are using
          this{" "}
          <span className="font-bold">
            Powerful Tool while

            Hiring Freshers
          </span>
          .
          <br />
          <span className="font-bold text-2xl max-md:text-xl text-yellow-300">
            {" "}
            ARE YOUR STUDENTS USING IT?
          </span>
        </p>
      </div>
      <div className="bg-[#f3f4f6] text-gray-800 p-6 md:px-10 md:py-16 space-y-10">
        <div className="text-center max-w-5xl mx-auto space-y-6">
          <p className="text-md md:text-xl max-md:pt-4">
            In today’s competitive job market, resumes and grades only tell half
            the story.
          </p>

          <div className="bg-[#dce9fd] rounded-[35px] p-6 px-12 max-md:px-4 md:p-8 space-y-6">
            <h2 className="text-base md:text-xl  text-indigo-800">
              What recruiters truly want to know is
            </h2>
            <div className="grid md:grid-cols-2 gap-6 text-base md:text-lg text-gray-900 px-8 md:px-16">
              <div className="flex items-start text-start font-medium gap-2">
                <img src={requestcpy} alt="request-cpy" className="object-cover" />
                Will this candidate thrive in our company culture?
              </div>
              <div className="flex items-start text-start font-medium gap-2">
                <img src={requestcpy} alt="request-cpy" className="object-cover" />
                Do they have the mindset to grow, adapt, and lead?
              </div>
            </div>
          </div>

          <p className="text-base md:text-lg text-gray-700  max-md:pb-4">
            <span className="text-indigo-700 font-semibold">SelfSync.ai</span>{" "}
            offers a personality assessment platform that works like a{" "}
            <a
              href="#"
              className="text-indigo-700  hover:text-blue-800 font-medium"
            >
              CIBIL report for freshers
            </a>{" "}
            giving companies deeper insights into candidate potential, fit, and
            behavioral strengths.
          </p>
        </div>
      </div>

      <div className="bg-white">
        <div className="grid md:grid-cols-2 items-center gap-10 max-w-6xl mx-auto pt-12 md:px-4 pb-12 bg-white">
          <div className="relative w-full max-w-sm mx-auto rounded-2xl  overflow-hidden">
            <img
              src={blubimg}
              alt="Interview"
              className=" md:w-full h-auto object-cover bg-transparent "
            />
          </div>

          <div className="space-y-4  md:text-left px-6 pb-8">
            <h3 className="text-4xl md:text-6xl font-bold bg-gradient-to-r pb-3 max-md:pb-2 from-purple-600 to-cyan-500 text-transparent bg-clip-text  ">
              What Is <br className="mt-1" /> SelfSync.ai?
            </h3>
            <p className="text-gray-900 text-base font-medium md:text-lg mt-2 text-start leading-7 ">
              SelfSync is an{" "}
              <span className=" text-indigo-700">
                AI-powered personality assessment tool
              </span>{" "}
              designed to help placement cells evaluate students’ workplace
              behavior, leadership potential, and team compatibility. It brings{" "}
              <span className="font-semibold text-indigo-700">
                science-backed insights
              </span>{" "}
              into the hiring process for better placements, stronger employer
              relations, and more confident students.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-br from-[#edebfc] to-[#ddf5ff] pt-12 pb-16 px-4 md:px-16">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-12">
          Why Placement Cells Love SelfSync?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12  max-w-6xl mx-auto ">
          {benefits.slice(0, 3).map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-[30px] shadow-xl px-6 py-6  flex flex-col items-start space-y-3"
            >
              {item.icon}
              <h3 className="text-lg font-semibold text-black">{item.title}</h3>
              <p className="text-gray-600 font-medium ">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-3xl mx-auto mt-14 mb-4">
          {benefits.slice(3).map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-[30px]  px-6 py-6 md:py-10 flex flex-col items-start space-y-4 shadow-xl"
            >
              {item.icon}
              <h3 className="text-lg font-semibold text-gray-900">
                {item.title}
              </h3>
              <p className="text-gray-600 font-medium ">{item.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-white">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-center px-14 max-md:px-8 py-14 md:py-20">
          <div>
            <h2 className="text-4xl md:text-6xl font-bold bg-gradient-to-r from-purple-600 to-cyan-500 bg-clip-text text-transparent mb-1 pb-4">
              What <br /> Companies See
            </h2>
            <p className="text-gray-700 text-bas mb-6">
              Companies receive a 360° profile of each student, including:
            </p>
            <ul className="space-y-3">
              {insights.map((point, index) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="bg-gray-200 p-1 max-md:p-0.5 rounded-lg">
                    <FaCheck className="text-green-500 text-md" />
                  </div>
                  <span className="text-black font-medium text-xl max-md:text-base">
                    {point}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex  max-ms:justify-center">
            <img
              src={searchimg}
              alt="Company View"
              className="rounded-2xl  max-w-xs md:max-w-sm"
            />
          </div>
        </div>

        <div className="bg-gradient-to-br from-[#fbfcff45] to-[#ddf5ff] py-12  md:pb-20 md:py-12 px-4 max-md:pb-20">
          <h3 className="text-center  font-bold text-4xl md:text-5xl  bg-[#3b3dcd] bg-clip-text text-transparent mb-10">
            The Result?
          </h3>

          <div className="grid sm:grid-cols-2 md:grid-cols-2 gap-6 max-w-3xl mx-auto rounded-xl">
            {results.map((item, index) => (
              <div
                key={index}
                className="flex items-center gap-3 bg-white shadow-md rounded-2xl px-4 py-6"
              >
                {item.icon}
                <p className="text-base text-gray-700 font-bold">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-br from-[#7b3ad7] to-[#4183e3] text-white py-16  px-4 text-center">
        <h2 className="text-3xl md:text-5xl text-white font-bold mb-4">
          The Result?
        </h2>

        <p className="text-sm md:text-lg max-w-4xl mx-auto mb-6">
          We’re offering <span className="font-semibold">free trials</span> for
          select colleges this month. <br />Let’s schedule a quick 15-minute
          walkthrough to show how your students and recruiters can benefit
        </p>

        <button
          className="bg-white text-purple-700 font-bold px-6 md:px-10 py-2 rounded-md shadow-md hover:bg-gray-100 transition text-lg md:text-xl"
          onClick={() => setIsModalOpen(true)}
        >
          BOOK A DEMO
        </button>
      </div>
      {isModalOpen && <ModalFormStudent isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />}
    </div>
  );
}

export default StudentLandingPage;
